(function() {
  "use strict";

  angular
    .module("admin.offers.service", [])
    .factory("OffersService", OffersService);

  /** @ngInject */
  function OffersService($http, $q, API) {
    function list() {
      var defered = $q.defer();

      $http
        .get(API.API_URL + "admin/offers")
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function listTranslations(id) {
      var defered = $q.defer();

      $http
        .get(API.API_URL + "admin/offers/" + id + "/offer_translations")
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function listPublish(start, limit, sort) {
      var defered = $q.defer();

      $http
        .get(
          API.API_URL +
            "admin/offers/published?start=" +
            start +
            "&limit=" +
            limit +
            "&sort=" +
            sort
        )
        .success(defered.resolve);

      return defered.promise;
    }

    function listUnpublish(start, limit, sort) {
      var defered = $q.defer();

      $http
        .get(
          API.API_URL +
            "admin/offers/unpublished?start=" +
            start +
            "&limit=" +
            limit +
            "&sort=" +
            sort
        )
        .success(defered.resolve);

      return defered.promise;
    }

    function listArchived(start, limit, sort) {
      var defered = $q.defer();

      $http
        .get(
          API.API_URL +
            "admin/offers/archived?start=" +
            start +
            "&limit=" +
            limit +
            "&sort=" +
            sort
        )
        .success(defered.resolve);

      return defered.promise;
    }

    function get(id) {
      var defered = $q.defer();

      $http.get(API.API_URL + "admin/offers/" + id).success(defered.resolve);

      return defered.promise;
    }

    function getTranslation(id) {
      var defered = $q.defer();

      $http.get(API.API_URL + "admin/offer_translations/" + id).success(defered.resolve);

      return defered.promise;
    }

    function save(model) {
      var defered = $q.defer();

      $http.post(API.API_URL + "admin/offers", model).success(defered.resolve);

      return defered.promise;
    }

    function saveTranslation(id, model) {
      var defered = $q.defer();

      $http.post(API.API_URL + "admin/offers/" + id + "/offer_translations?automatic=true", model).success(defered.resolve);

      return defered.promise;
    }

    function updateTranslation(offerId, id, model) {
      var defered = $q.defer();

      $http
        .put(API.API_URL + "admin/offers/" + offerId + "/offer_translations/" + id + '?automatic=true', model)
        .success(defered.resolve);

      return defered.promise;
    }

    function update(id, model) {
      var defered = $q.defer();

      $http
        .put(API.API_URL + "admin/offers/" + id, model)
        .success(defered.resolve);

      return defered.promise;
    }

    function remove(id) {
      var defered = $q.defer();

      $http
        .delete(API.API_URL + "admin/offers/" + id)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function removeTranslation(offerId, id) {
      var defered = $q.defer();

      $http
        .delete(API.API_URL + "admin/offers/" + offerId + "/offer_translations/" + id)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function publish(id) {
      var defered = $q.defer();

      $http
        .post(API.API_URL + "admin/offers/" + id + "/publish")
        .success(defered.resolve)
        .error(function(result) {
          swal(result.error.message, "", "error");
        });

      return defered.promise;
    }

    function unpublish(id) {
      var defered = $q.defer();

      $http
        .post(API.API_URL + "admin/offers/" + id + "/unpublish")
        .success(defered.resolve)
        .error(function(result) {
          swal(result.error.message, "", "error");
        });

      return defered.promise;
    }

    function listOfferSegmentation(id) {
      var defered = $q.defer();

      $http
        .get(API.API_URL + "admin/offers/" + id + "/user_segments")
        .success(defered.resolve);

      return defered.promise;
    }

    function listOfferSegmentationUsers(id) {
      var defered = $q.defer();

      $http
        .get(API.API_URL + "admin/offers/" + id + "/user_segmenter_users")
        .success(defered.resolve);

      return defered.promise;
    }

    function addOfferSegmentation(id, segmentId) {
      var defered = $q.defer();

      $http
        .post(
          API.API_URL + "admin/offers/" + id + "/user_segments/" + segmentId
        )
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function removeOfferSegmentation(id, segmentId) {
      var defered = $q.defer();

      $http
        .delete(
          API.API_URL + "admin/offers/" + id + "/user_segments/" + segmentId
        )
        .success(defered.resolve);

      return defered.promise;
    }

    function reorder(id, order) {
      var defered = $q.defer();

      $http
        .put(API.API_URL + "admin/offers/" + id + "/order/" + order)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }


    function listBundlesByChannelId(channelId) {
      console.log('Hitting bundles API for channel:', channelId)

      var deferred = $q.defer()

      $http
        .get(API.API_URL + 'publisher/channels/' + channelId + '/bundles')
        .success(deferred.resolve)
        .error(deferred.reject)

      return deferred.promise
    }

    return {
      list: list,
      listPublish: listPublish,
      listUnpublish: listUnpublish,
      listArchived: listArchived,
      listOfferSegmentation: listOfferSegmentation,
      listOfferSegmentationUsers: listOfferSegmentationUsers,
      listTranslations: listTranslations,
      get: get,
      getTranslation: getTranslation,
      save: save,
      saveTranslation: saveTranslation,
      update: update,
      updateTranslation: updateTranslation,
      remove: remove,
      removeTranslation: removeTranslation,
      publish: publish,
      unpublish: unpublish,
      addOfferSegmentation: addOfferSegmentation,
      removeOfferSegmentation: removeOfferSegmentation,
      reorder: reorder,
      listBundlesByChannelId: listBundlesByChannelId,

    };
  }
})();
